import { CarrierContract } from '~api/carrier_contracts';

import { ReactNode, useState } from 'react';

import { ListLayout, Modal, ModalSelect, OptionList, SearchInput } from '@ingrid/luterkort-react';

import { SelectModal } from '~src/components/Modal/Modal';
import { useTranslation } from '~src/i18n/use-translation';
import { useCarrierContractsListQuery } from '~src/pages/settings/carrier-contract/queries';

export interface CarrierContractSelectProps {
  shipping_method?: string;
  value?: CarrierContract;
  onValueChange: (value?: CarrierContract) => void;
  mode: 'add' | 'update';
  trigger: ReactNode;
}

export function CarrierContractSelect({
  shipping_method,
  value,
  onValueChange,
  ...modalProps
}: CarrierContractSelectProps) {
  const { t } = useTranslation();
  const [search, setSearch] = useState<string>();
  const { data: contracts } = useCarrierContractsListQuery({ shipping_method, query: search });

  return (
    <SelectModal
      filterFactory={false}
      searchValue={search}
      onSearchValueChange={setSearch}
      value={value?.contract_id ? [value.contract_id] : ['']}
      onValueChange={v => onValueChange(contracts?.find(c => c.contract_id === v[0]))}
      {...modalProps}
    >
      <Modal.Header title={t('common.selectCarrierContract')} />

      <ModalSelect.Content>
        <ModalSelect.Control>
          <SearchInput placeholder={t('shipments.carrierContract.searchPlaceholder')} />
        </ModalSelect.Control>

        <OptionList.Viewport>
          {contracts?.map(c => (
            <OptionList.Item key={c.contract_id} spacing="sm" value={c.contract_id!}>
              <ListLayout.Stack>
                <ListLayout.PrimaryText
                  css={{
                    lineHeight: '16px',
                  }}
                >
                  <OptionList.ItemText>{c.name}</OptionList.ItemText>
                </ListLayout.PrimaryText>
                <ListLayout.SecondaryText
                  css={{
                    lineHeight: '20px',
                  }}
                >
                  {c.description} <br />
                  {c.carrier_configuration_data ? JSON.parse(c.carrier_configuration_data).customer_number : ''}
                </ListLayout.SecondaryText>
              </ListLayout.Stack>
            </OptionList.Item>
          ))}
        </OptionList.Viewport>
      </ModalSelect.Content>
    </SelectModal>
  );
}
